"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.setUpActivityToggle = exports.promptToRestartStream = exports.pollFeatures = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _actions = require("./actions");

var _featuresReducer = _interopRequireDefault(require("./featuresReducer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // enhancement - pause on inactivity - from server or browser - show dialog and resume on OK


var pollFeatures = function pollFeatures(subscribingFeatures$, activityToggle$, projectId, serverAjax, SERVER_URL) {
  return (0, _rxjs.combineLatest)(subscribingFeatures$, activityToggle$).pipe( // we might want something other than switchMap here as it will
  // throw away inflight requests when the features change, but maybe that is good
  (0, _operators.switchMap)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        features = _ref2[0],
        activityToggle = _ref2[1];

    return activityToggle ? serverAjax({
      method: "POST",
      url: "".concat(SERVER_URL, "/long-polling-feature"),
      headers: {
        //  we cannot set application/json as a content type without triggering CORS preflight request
        // so we set text/plain and decode the body on the server
        "Content-Type": "text/plain"
      },
      body: JSON.stringify({
        features: Object.keys(features).map(function (featureId) {
          return {
            featureId: featureId,
            currentUpdateId: features[featureId].updateId
          };
        }),
        projectId: projectId
      }),
      responseType: "json",
      crossDomain: true,
      withCredentials: true,
      // pass editor authentication cookies with request
      createXHR: function createXHR() {
        return new XMLHttpRequest();
      }
    }).pipe((0, _operators.retryWhen)(function (error) {
      return error.pipe((0, _operators.delay)(5000));
    })) // Retry if there is an error, delay 5 seconds)
    : _rxjs.NEVER;
  }), (0, _operators.pluck)("response"), (0, _operators.map)(_actions.featuresFromServer));
};

exports.pollFeatures = pollFeatures;

var promptToRestartStream = function promptToRestartStream(actions$) {
  var prompt = window.confirm("Realtime preview has been paused due to inactivity, click OK to resume");

  if (prompt) {
    actions$.next({
      type: "RESUME"
    });
  }
}; // no new output (new features subscribing or new data from server) for 5 minutes, pause subscription and
// show prompt to user to restart


exports.promptToRestartStream = promptToRestartStream;

var setUpActivityToggle = function setUpActivityToggle(subscribingFeatures$, actions$) {
  return subscribingFeatures$.pipe((0, _operators.switchMap)(function () {
    return (0, _rxjs.of)(false).pipe( // 5 minutes
    (0, _operators.delay)(60 * 5 * 1000), (0, _operators.tap)(function () {
      promptToRestartStream(actions$);
    }));
  })).pipe((0, _operators.startWith)(true));
};

exports.setUpActivityToggle = setUpActivityToggle;

var _default = function _default(_ref3, ajax) {
  var projectId = _ref3.projectId,
      apiUrl = _ref3.apiUrl; // create subject to stream observe actions & responses from the server

  var actions$ = new _rxjs.Subject(); // our reducer and local state

  var subscribingFeatures$ = actions$.pipe((0, _operators.scan)(_featuresReducer.default, {})); // circular polling of the server

  var pollFeaturesSubscription = pollFeatures(subscribingFeatures$, // no new output (new features subscribing or new data from server) for 5 minutes, pause subscription and
  // show prompt to user to restart
  setUpActivityToggle(subscribingFeatures$, actions$), projectId, ajax, apiUrl).subscribe(actions$); // this should emit to action and then immeditately reconnect on the top

  return {
    features: subscribingFeatures$.pipe((0, _operators.finalize)(function () {
      actions$.complete();
      pollFeaturesSubscription.unsubscribe();
    }), (0, _operators.publishBehavior)({}) // default state
    ),
    // create a dispatcher to send events to the server
    dispatch: function dispatch(func) {
      return function () {
        return actions$.next(func.apply(void 0, arguments));
      };
    }
  };
};

exports.default = _default;